import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const PageHero = ({ breadcrumbs, label, title, description, testId }) => (
  <section className="relative overflow-hidden bg-[#141416] border-b border-[#2A2A2D]">
    <div className="absolute inset-0 opacity-[0.02]" style={{ backgroundImage: "repeating-linear-gradient(45deg, #D4AF37 0px, #D4AF37 1px, transparent 1px, transparent 40px)" }} />
    <div className="absolute top-0 right-0 w-[500px] h-[300px] bg-[#D4AF37]/[0.04] rounded-full blur-[100px] -translate-y-1/2 translate-x-1/4" />
    <div className="max-w-5xl mx-auto px-6 md:px-12 py-16 md:py-24 relative">
      {breadcrumbs && (
        <nav className="flex items-center gap-2 text-[10px] tracking-wider text-[#B8B8B8]/40 mb-8" data-testid={`${testId}-breadcrumbs`}>
          <Link to="/" className="hover:text-[#D4AF37] transition-colors">START</Link>
          {breadcrumbs.map((bc, i) => (
            <span key={i} className="contents">
              <span>/</span>
              {bc.href ? (
                <Link to={bc.href} className="hover:text-[#D4AF37] transition-colors">{bc.label}</Link>
              ) : (
                <span className="text-[#D4AF37]">{bc.label}</span>
              )}
            </span>
          ))}
        </nav>
      )}
      {label && (
        <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-[10px] tracking-[0.3em] text-[#D4AF37] block mb-4">
          {label}
        </motion.span>
      )}
      <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}
        className="font-serif text-[clamp(1.8rem,4.5vw,3.2rem)] text-[#F5F5F5] leading-tight mb-6" data-testid={`${testId}-h1`}
      >
        {title}
      </motion.h1>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.15 }} className="w-16 h-px bg-[#D4AF37]/40 mb-6" />
      <motion.p initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}
        className="text-[#B8B8B8] text-sm md:text-base leading-relaxed max-w-3xl"
      >
        {description}
      </motion.p>
    </div>
  </section>
);

export default PageHero;
